'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_a1e6048f = {"collapse-overflow":"Transition_module_collapseOverflow__c54368b9","collapse-visible":"Transition_module_collapseVisible__c54368b9","collapse-hidden":"Transition_module_collapseHidden__c54368b9"};
require("../../../assets/cjs/components/Transition/src/Collapse~Brpnly8z.css");

exports.default = modules_a1e6048f;
//# sourceMappingURL=Transition.module.less.js.map
